module.exports = __webpack_public_path__ + "img/24.ac0d02c2.png";